// extracted by mini-css-extract-plugin
export default {"categoryLinksWrapper":"style-module--categoryLinksWrapper--b6896"};